export enum ViewPort {
  DESKTOP = 'deskTop',
  MOBILE = 'mobile',
}
export enum CANARY_MISSION {
  NAME = 'Canary Mission',
  BASIC_URL = 'https://canarymission.org',
  HYBRID_APP_URL = 'https://icpwsproduction.com',
  X_TWITTER = '@canarymission',
  KEYWORDS = 'Canary Mission, BDS, Anti-Semitism, Hatred',
  DEFAULT_LOGO  = 'https://cm2cdn.canarymission.org/static/images/canarymission_logo_grey_backgroud.jpg',
}
